import React from "react";
import { motion } from "framer-motion";

function QuoteSection() {
  return (
    <section className="quote-section">
      <div className="quote-mark">“</div>
      <motion.blockquote
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9 }}
      >
        The best nights aren't planned.
        <span>They're remembered.</span>
      </motion.blockquote>
      <div className="quote-line" />
      <p>— THE JALSA PHILOSOPHY</p>
    </section>
  );
}

export default QuoteSection;
